import axiosGlobalInstance from './axios-instance';
import uriApi from '../config/uriApi';

const getFinancial = params => {
  const { empresaId, dias } = params;
  return axiosGlobalInstance({
    method: 'GET',
    url: `${uriApi}/api/v1/contas-pagar/${dias}/${empresaId}`
  });
};

export default getFinancial;
